<nav class="navbar navbar-expland-lg navbar-light {ws_cnx_up ? 'ws_online' : 'ws_offline'}">
    <span id="spn:CHANNEL_NAME"></span>{channel_encrypted}
</nav>
<div>{@html channel_template}</div>

<style>
.ws_online {
    background-color: #FFF
}
.ws_offline {
    background-color: #FF6961
}
</style>

<script lang='ts'>
    import { axiosPost } from '../c0utils'
    import { Result } from '../Result'
    import { DBC_URL } from '../store.js'
import Channel from './Channel.svelte'


    export let params = {
        name: null
    }

    let channel_encrypted = false
    let channel_template = 'Loading template...'
    let ws_cnx_up = false

    function process_xlrange_flat(result, delimiter=':') {
        let resp_str
        if(typeof(result) != 'string') { resp_str = JSON.stringify(result) }
        let response = JSON.parse(resp_str.split('NaN').join('null'));
        if(response.data === null) response.data = ""
        let xlrange
        if(typeof(response.data) == 'object' &&
            !Array.isArray(response.error_msg) &&
            '|-|RANGE' in response.data) xlrange = response.data['|-|RANGE']
        else xlrange = response.data
        console.log("!!! xlrange: ", xlrange)
        if(typeof(xlrange) === 'string') xlrange = JSON.parse(xlrange)
        console.log(typeof(xlrange), Array.isArray(xlrange))
        if(Array.isArray(xlrange)) xlrange = Object.fromEntries(xlrange)
        console.log("!!!!! xlrange:", xlrange)
        for(var attr_key in xlrange) {
            // console.log(attr_key, xlrange[attr_key]);
            var blk_name = 'blk' + delimiter + attr_key;
            // console.log(blk_name)
            var btn_name = 'btn' + delimiter + attr_key;
            var chk_name = 'chk' + delimiter + attr_key;
            var gmb_name = 'gmb' + delimiter + attr_key;
            var inp_name = 'inp' + delimiter + attr_key;
            var lnk_name = 'lnk' + delimiter + attr_key;
            var sel_name = 'sel' + delimiter + attr_key;
            var spn_name = 'spn' + delimiter + attr_key;
            var txt_name = 'txt' + delimiter + attr_key;
            var var_name = 'var' + delimiter + attr_key;
            if(document.getElementById(blk_name)) document.getElementById(blk_name).innerHTML = xlrange[attr_key];
            else if(document.getElementById(btn_name)) { if(xlrange[attr_key]=="0") xlrange[attr_key]=false; if(xlrange[attr_key]) document.getElementById(btn_name).dispatchEvent(new Event('click')); }
            else if(document.getElementById(chk_name)) { if(xlrange[attr_key]=="0") xlrange[attr_key]=false; (<HTMLInputElement>document.getElementById(chk_name)).checked = Boolean(xlrange[attr_key]); }
            else if(document.getElementById(inp_name)) { (<HTMLInputElement>document.getElementById(inp_name)).value = xlrange[attr_key]; document.getElementById(inp_name).dispatchEvent(new Event('change')); }
            else if(document.getElementById(gmb_name)) { if(xlrange[attr_key]) document.getElementById(gmb_name).dispatchEvent(new Event('click')); }
            else if(document.getElementById(lnk_name)) (<HTMLAnchorElement>document.getElementById(lnk_name)).href = xlrange[attr_key];
            else if(document.getElementById(sel_name)) { (<HTMLInputElement>document.getElementById(sel_name)).value = xlrange[attr_key]; document.getElementById(sel_name).dispatchEvent(new Event('change')); }
            else if(document.getElementById(spn_name)) document.getElementById(spn_name).innerHTML = xlrange[attr_key];
            else if(document.getElementById(txt_name)) { if(xlrange[attr_key]!=null) document.getElementById(txt_name).innerHTML = xlrange[attr_key]; }
            else if(document.getElementById(var_name)) { document.getElementById(var_name).innerHTML = xlrange[attr_key]; }
        };
    }


    if(params.name) {
        const channel_name = params.name
        const url_read = DBC_URL + '/channel/read'
        const url_wss = 'wss://api.easywebsocket.com/wss/databroadcaster/' + channel_name
        console.log("ws created")

        let ping;
        let last_ping_dt = Date.now();
        let ws = new WebSocket(url_wss)

        axiosPost(DBC_URL + '/channel/template', {CHANNEL: { name: channel_name}})
        .then((r) => {
            const result = new Result()
            result.from_json(r)
            if(result.ok) {
                channel_template = result.data
            }
        })
        

        function check_online() {
            ws.send(JSON.stringify({'KIND': 'ping'}));
            //delta_dt = Date.now() - last_ping_dt;
            //if(delta_dt > 130000) {
            //  $('#header').css('background-color', '#FF6961');
            //}
        }

        ws.onopen = function() {
            /* get last message */
            axiosPost(url_read, {
                CHANNEL: {
                    name: channel_name
                }
            })
            .then((r) => {
                const result = new Result()
                result.from_json(r)
                if(result.ok) {
                    channel_encrypted = result.misc['encrypted']
                    process_xlrange_flat(result)
                    //TODO: ws authentication
                    const user_uuid = 'uuid'
                    const user_pkey = 'pkey'
                    ws.send(JSON.stringify({'KIND': 'init', 'CHANNEL_UUID': channel_name, 'USER_UUID': user_uuid, 'USER_PKEY': user_pkey}))
                    ws_cnx_up = true
                }
            })
        }

        ws.onmessage = function(msg) {
            console.log(msg);
            const result = new Result()
            result.from_ws_msg(msg)
            console.log(result.ok, result.data)
            if(result.ok && result.data) process_xlrange_flat(result);
        };

        ws.onclose = function() {
            ws_cnx_up = false
            var now = new Date();
            var ts = ('0' + now.getHours()).slice(-2) + ':' + ('0' + now.getMinutes()).slice(-2);
            //$('#chatflow_{{str()}}').prepend('<div style="color: #FF6961;"><i>[' + ts + '] eloquents:: you are now offline...</i></div>');
            clearTimeout(ping);
            console.log("WS connection closed")
        }
    }
</script>